module.exports = __webpack_public_path__ + "static/media/puzzle-center.53783ce7.png";